/* @indexer:no-export */
import * as React from 'react';
import './DraggableActions.css';
export default function DraggableActions(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "draggable-box__actions"
  }, children);
}